import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setSearchForm, setErrorMessage } from '../../stories/actions';
import { getConfirmePasswordResetEmail } from '../../services/api';
import { isEmpty, isValidPasswd } from "../../utilities/methods";
import bcrypt from "bcryptjs-react";

import Footer from '../Footer/Footer';

import "./Form.css";

const FormResetPasswd = ({ users, tokensExpire, sendToken, setSearchFormAction, errorMessage, setErrorMessageAction }) => {
    const [passwd, setPasswd] = useState("");
    const [passwdConfirm, setPasswdConfirm] = useState("");
    const [isShowPasswd, setIsShowPasswd] = useState(false);
    const [passwdType, setPasswdType] = useState("password");
    const [iconShowPasswd, setIconShowPasswd] = useState("visibility_off");

    const handlerPasswdType = () => {
        if (isShowPasswd) {
            setPasswdType("password");
            setIconShowPasswd("visibility_off");
        } else {
            setPasswdType("text");
            setIconShowPasswd("visibility");
        }

        setIsShowPasswd(!isShowPasswd);
    };

    const handlerHiddenPasswdType = () => {
        if (isShowPasswd) {
            setPasswdType("password");
            setIconShowPasswd("visibility_off");
        }

        setIsShowPasswd(!isShowPasswd);
    };

    const navigateTo = useNavigate();

    const handlerChangePasswd = (e) => {
        const value = e.target.value;
        setPasswd(value);
    };

    const handlerChangePasswdConfirm = (e) => {
        const value = e.target.value;
        setPasswdConfirm(value);
    };

    const handlerKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
        }

        handlerSaveNewPassword();
    };

    const handlerSaveNewPassword = async () => {
        if (isEmpty(passwd)) {
            setErrorMessageAction("Estes campos são obrigatórios.");
        } else if (!isValidPasswd(passwd) || !isValidPasswd(passwdConfirm)) {
            setErrorMessageAction("A senha deve ter pelo menos 8 caracteres, incluindo uma letra maiúscula, um caractere especial e um número.");
        } else if (passwdConfirm !== passwd) {
            setErrorMessageAction("As senhas não conferem.");
        } else {
            const token = tokensExpire.find(token => token.token.trim() === sendToken.trim());

            if (token) {
                const now = new Date();
                const expireTime = new Date(token.tokenExpiration);

                if (now >= expireTime) {
                    handlerTimeExpire();
                } else {
                    const user = users.find(user => user.token.trim() === sendToken.trim());

                    if (user) {
                        const saltRounds = 10;
                        const hashPasswd = await bcrypt.hash(passwd, saltRounds);

                        await getConfirmePasswordResetEmail(user, hashPasswd).then(() => {
                            handlerUserLogin();
                        });
                    }
                }
            }
        }
    };

    const handlerUserLogin = () => {
        setErrorMessageAction("");
        setSearchFormAction("login");
        window.location.href = window.location.origin;
    };

    const handlerUserRegister = () => {
        setErrorMessageAction("");
        setSearchFormAction("register");
        navigateTo("/?page-register=true");
    };

    const handlerUserSendEmail = () => {
        setErrorMessageAction("");
        setSearchFormAction("sendemail");
        navigateTo("/?page-sendemail=true");
    };

    const handlerTimeExpire = () => {
        setErrorMessageAction("");
        setSearchFormAction("timeExpire");
        navigateTo("/?page-time-expire=true");
    };

    return (
        <div className='row'>
            <div className='col-md-3'></div>

            <div className='col-md-12 form_container'>
                <div className='form_card'>
                    <div className="mb-2">
                        <small className={errorMessage ? "label_form_style response_message" : "label_form_style"}>{errorMessage}</small>
                    </div>

                    <div className="mb-2">
                        <h4 className='label_form_title_paragraph'>Formulário para alteração de senha</h4>
                    </div>

                    <div className="mb-2">
                        <label className="label_form_style">Senha</label>
                        <div className='input_group_container'>
                            <input type={passwdType}
                                value={passwd}
                                placeholder='********'
                                onChange={handlerChangePasswd}
                                className='form-control input_theme_style' />
                            <span className="material-symbols-outlined icon_visible_input_passwd"
                                onClick={handlerPasswdType}
                                onMouseOut={handlerHiddenPasswdType}>visibility_off</span>
                        </div>
                    </div>

                    <div className="mb-4">
                        <label className="label_form_style">Confirme sua senha</label>
                        <div className='input_group_container'>
                            <input type={passwdType}
                                value={passwdConfirm}
                                placeholder='********'
                                onChange={handlerChangePasswdConfirm}
                                onKeyDown={handlerKeyPress}
                                className='form-control input_theme_style' />
                            <span className="material-symbols-outlined icon_visible_input_passwd"
                                onClick={handlerPasswdType}
                                onMouseOut={handlerHiddenPasswdType}>visibility_off</span>
                        </div>
                    </div>

                    <div className="mb-4 col-md-6">
                        <div className='button_group_container' onClick={handlerSaveNewPassword}>
                            <span className="button_group_paragraph_style">Salvar senha</span>
                            <span className="material-symbols-outlined button_group_icon_style"> save </span>
                        </div>
                    </div>

                    <div className="mb-2">
                        <span className='button_link_form_style' onClick={handlerUserSendEmail}>Esqueci minha senha</span>
                    </div>

                    <div className="mb-2">
                        <span className='button_link_form_style' onClick={handlerUserLogin}>Tenho uma conta</span>
                    </div>

                    <div className="mb-2">
                        <span className='button_link_form_style' onClick={handlerUserRegister}>Registre-se</span>
                    </div>
                </div>
            </div>

            <div className='col-md-3'></div>

            <Footer />
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

const mapActionToProps = (dispatch) => {
    return {
        setSearchFormAction: (searchForm) => dispatch(setSearchForm(searchForm)),
        setErrorMessageAction: (errorMessage) => dispatch(setErrorMessage(errorMessage))
    };
};

export default connect(mapStoreToProps, mapActionToProps)(FormResetPasswd);